import { Friend } from '../ContextProviders/friendContextTypes';
import { FFFSOCIAL_PLANCODE } from './registerConnector';

export default function createIterableProfile(friend: Friend, userId: string) {
  const {
    firstName, lastName, address, phoneNumber, email,
  } = friend;
  const {
    shipAddress1, shipAddress2, shipCity, shipCountry, shipState, shipZipCode,
  } = address;
  window.analytics.identify(userId, {
    email,
    Subscriptions: [
      {
        plan_code: FFFSOCIAL_PLANCODE,
        first_name: firstName,
        ship_address1: shipAddress1,
        subscription_state: 'active',
        ship_zipcode: shipZipCode,
        ship_phone: phoneNumber,
        ship_city: shipCity,
        type: 'FabFitFun',
        ship_country: shipCountry,
        ship_address2: shipAddress2,
        ship_state: shipState,
        last_name: lastName,
        roles: 'customer',
      },
    ],
  });
}
